import React from 'react';
import { Grid, Box, H2, P, Type } from '@saladbob/sassafras'

import Image from '../media/Image';

import { EyeOff } from 'react-feather';

import { TeamDepth } from '../../types';

type TeamColorsProps = {
    color: string;
    color2: string;
    width: number;
}

type Props = {
    team: TeamDepth;
    draft?: boolean;
    onClick?: () => void;
}

const getInitials = (name: string) => {
    if (!name) return '';
    const teamInitials = name.split(' ').reduce((reducer, word) => {
        if (word.toLowerCase() !== 'the') {
            if (word[0]) {
                reducer.push(word[0].toUpperCase());
            }
        }
        return reducer;
    }, []).join('');

    return teamInitials;
};

const TeamCard: React.FC<Props> = ({ team, onClick, draft }) => {
    return (
        <Box
            key={team.id}
            role="button"
            bdColor="neutral50"
            depth="xs"
            bgColor="neutral50"
            onClick={onClick}
        >
            <Grid columns="minMax(64px, 100px) 1fr" rows="minMax(100px, 1fr)" align="center">
                <div style={{ position: 'relative', width: '100%', height: '100%', backgroundColor: team.color}}>
                    {team.logo && (
                        <Box width="100%" height="100%" bgColor={team.color}>
                            <Image image={team.logo} size="thumbnail" alt={team.name} />
                        </Box>
                    )}
                    {!team.logo && (
                        <Box height="100%" justify="center" align="center" gradient={[team.color, team.color2]} gradientDirection="45deg">
                            <H2 font="leader" color="white">
                                {getInitials(team.name)}
                            </H2>
                        </Box>
                    )}
                </div>
                <Box padding={{ phone: ['xxs', 'sm'], laptop: 'sm' }}>
                    <H2
                        font={{ phone: 'p', laptop: 'h3' }}
                        mb={{phone: 0, laptop: 'xs'}}
                        uppercase
                        nowrap
                    >
                        {team.name}
                    </H2>
                    <Box
                        align="center"
                        justify="space-between"
                    >
                        {team.players && team.players.length > 0 && team.players.map((player, index) => (
                            <P mb="0" me={index < 3 ? 'sm' : ''} color="neutral" nowrap>
                                {player && player.fname && player.fname[0]
                                    ? (<>
                                        {player.fname[0]}
                                        <span className="hide-on-mobile">
                                            {player && player.lname}
                                        </span>
                                        <span className="hide-on-laptop">
                                            {player && player.lname && player.lname[0]}.
                                        </span>
                                    </>)
                                    : (<EyeOff size={16} />)
                                }
                            </P>
                        ))}
                    </Box>
                </Box>
            </Grid>
            {draft && (
                <Type bgColor="neutral200" color="neutral" font="control" padding={[0, 'xs']} style={{ position: 'absolute', top: 0, right: 0 }}>
                    DRAFT
                </Type>
            )}
        </Box>
    );
};

export default TeamCard;